
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M233.56 111.33v27.15a10 10 0 01-10 10H118.94v14.15h66.38a10 10 0 0110 10v27.14a10 10 0 01-10 10h-12.66a5 5 0 01-5-5 5 5 0 015-5h12.66v-27.14H38.57v27.14h109.58a5 5 0 015 5 5 5 0 01-5 5h-29.21v19.69a5 5 0 01-10 0v-19.69H38.57a10 10 0 01-10-10v-27.14a10 10 0 0110-10h70.37v-14.15H86.78a10 10 0 01-10-10v-27.15a10 10 0 0110-10h22.16V87.18H47.56a10 10 0 01-10-10V50a10 10 0 0110-10h15.57a5 5 0 010 10H47.56v27.18h102.61V50H81.86a5 5 0 010-10h27.08V9.44a5 5 0 1110 0V40h31.23a10 10 0 0110 10v27.18a10 10 0 01-10 10h-31.23v14.15h104.62a10 10 0 0110 10z"}})])
          )
        }
      }
    